<template>
  <v-container fluid>
     <v-row justify="center" alignment="center">
      <v-col cols="12" md="8" class="text-center">
        <h1>Pass</h1>
      </v-col>
    </v-row>
    <v-form 
      ref="bankForm" 
      v-model="valid"
      class="bubble-form"
    >
      <v-row justify="center" alignment="center">
        <v-col cols="4">
          <v-switch
            v-model="residence"
            :label="residence"
            required
            inset
            :rules="rules.terms"
            false-value="IRE"
            true-value="UK"
          ></v-switch>
        </v-col>
        <v-col cols="4">
          <v-img
            :src="flagImage"
            height="80"
            max-width="120"
            contain
            ></v-img>
        </v-col>
      </v-row>
      <v-row justify="center" alignment="center" v-if="residence=='UK'">
        <v-col cols="8">
          <v-text-field
            v-model="form.bank['accNum']"
            :label="text.fieldLabels[3]"
            required
            :rules="rules.accountNumberRules"
            solo
            :return-masked-value="false"
            mask="########"
          ></v-text-field>
        </v-col>
        <v-col cols="8">
          <v-text-field
            v-model="form.bank['sortCode']"
            :label="text.fieldLabels[4]"
            solo
            :return-masked-value="false"
            mask="##-##-##"
            :rules="rules.sortCodeNumberRules"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row justify="center" alignment="center" v-else>
        <v-col cols="8">
          <v-text-field
            v-model="form.bank['iban']"
            :label="text.fieldLabels[1]"
            required
            solo
            :rules="rules.ibanNumberRules"
            :return-masked-value="false"
            mask="AANNNNNNNNNNNNNNNNNNNN"
          ></v-text-field>
        </v-col>
        <v-col cols="8">
          <v-text-field
            v-model="form.bank['bic']"
            :label="text.fieldLabels[2]"
            solo
            :rules="rules.bicSwiftNumberRules"
            :return-masked-value="false"
            mask="AAAAAA#ANNN"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row justify="center" align="center">
        <v-col cols="8">
          <v-btn @click="validate" block :loading="loading" color="primary" rounded dark depressed>{{text.submit}}</v-btn>
        </v-col>
      </v-row>
		</v-form>
  </v-container>
</template>
<script>
import siteData from "@/site-data";

export default {
  name: "valid-entry",
  mounted() {
  },
  beforeCreate() {
    
  },
  data: () => ({
    dialog:false,
    dialogText:{
      dialogTitle:'Oops! there was a problem.' ,
      dialogContent:'Try again',
      dialogNote: "To view our terms and conditions",
      dialogLinkText: "Click Here",
      dialogLinkTarget: "/terms"
    },
    receiptNull:true,
    sentCoupon:false,
    dialogButton:false,
    qualified:false,
    isMasked:false,
    intervalId: false,
    name: "",
    text: siteData.validEntryPage,
    emailAddress: "sample@emails.com",
    enteredDetails: false,
    residence: "UK",
    couponLink: "",
    valid: false,
    form: {
      bank: {
        accNum: "",
        sortCode: "",
        iban: "",
        bic: ""
      },
      captcha: false
    },
    rules: {
      accountNumberRules: [
        v => !!v || siteData.validEntryPage.rules.accNum.req,
        v => /^\d{8}$/.test(v) || siteData.validEntryPage.rules.accNum.pattern
      ],
      sortCodeNumberRules: [
        v => !!v || siteData.validEntryPage.rules.sortCode.req,
        v => /^\d{6}$/.test(v) || siteData.validEntryPage.rules.sortCode.pattern
      ],
      ibanNumberRules: [
        v => !!v || siteData.validEntryPage.rules.iban.req,
        v =>
          /^IE[0-9a-z]{20}/i.test(v) ||
          siteData.validEntryPage.rules.iban.pattern
      ],
      bicSwiftNumberRules: [
        v => !!v || siteData.validEntryPage.rules.bicSwift.req,
        v =>
          /^[a-z]{4}[a-z]{2}[0-2][a-z]([0-9a-z]{3}|)/i.test(v) ||
          siteData.validEntryPage.rules.bicSwift.pattern
      ]
    },
    uploadPercentage: 0,
    loading: false,
    clickedEmailCoupon: false
  }), // end data.
  methods: {
    validate: function() {
      //console.log("valadating...", this.$refs.bankForm.validate());
      if (this.$refs.bankForm.validate()) {
        this.$router.push('/thanks')
        return true
      }
    },
  },
  computed: {
    flagImage: function() {
      if(this.residence == "IRE") {
        return require('../assets/ire-flag.svg')
      }else{
        return require('../assets/uk-flag.svg')
      }
    }
  }
};
</script>
